import { httpsCallable } from 'firebase/functions';
import { functions } from './clients';
import type {
  CampaignAdminGateway,
  AdjustCampaignTaskPoolCommand,
  AdjustCampaignTaskPoolResult,
  UpdateCampaignTaskTypeSettingsCommand,
  UpdateCampaignTaskTypeSettingsResult,
} from '../../domain/campaigns/admin';

export function createFirebaseCampaignAdminGateway(): CampaignAdminGateway {
  return {
    async updateTaskTypeSettings(
      command: UpdateCampaignTaskTypeSettingsCommand,
    ): Promise<UpdateCampaignTaskTypeSettingsResult> {
      const fn = httpsCallable<
        UpdateCampaignTaskTypeSettingsCommand,
        UpdateCampaignTaskTypeSettingsResult
      >(functions, 'updateCampaignTaskTypeSettings');
      const result = await fn(command);
      return result.data;
    },
    async adjustTaskPool(
      command: AdjustCampaignTaskPoolCommand,
    ): Promise<AdjustCampaignTaskPoolResult> {
      const fn = httpsCallable<
        AdjustCampaignTaskPoolCommand,
        AdjustCampaignTaskPoolResult
      >(functions, 'adjustCampaignTasks');
      const result = await fn(command);
      return result.data;
    },
  };
}

export const firebaseCampaignAdminGateway = createFirebaseCampaignAdminGateway();

export function updateCampaignTaskTypeSettings(
  command: UpdateCampaignTaskTypeSettingsCommand,
): Promise<UpdateCampaignTaskTypeSettingsResult> {
  return firebaseCampaignAdminGateway.updateTaskTypeSettings(command);
}
